// extracted by mini-css-extract-plugin
module.exports = {"categories__description":"Categories-module--categories__description--25PEq"};